import styled from 'styled-components';

export const IconContainer = styled.div`
  --scale-factor: 1.5;

  & svg {
    transform: scale(var(--scale-factor));
  }
`;

export const DiscoveryCardWrapper = styled.div`
  [class*='DiscoveryCardstyle__DiscoveryCard-sc'] {
    height: 100%;
  }

  [class*='DiscoveryCardstyle__Content-sc'] {
    justify-content: flex-start;
  }

  [class*='Headingstyle__Heading-sc'] {
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
    margin: 8px 0;

    @media only screen and (max-width: 767px) {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
    }
  }


`;
